export class IngestionPipelinePurgeMetrics {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "outputId",
            "baseName": "outputId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "deletedObjects",
            "baseName": "deletedObjects",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelinePurgeMetrics.attributeTypeMap;
    }
    constructor() {
    }
}
